import React from "react"
import PropTypes from "prop-types"

const Section = ({color, children}) => {

  function setColor({color}) {
    if (color == true) {
      return <div className="section-wrapper bkg-color">{children}</div>;
    } else {
      return <div className="section-wrapper">{children}</div>;
    }
  }

  return (
    <React.Fragment>
      { setColor({color}) }
    </React.Fragment>
  );
}

Section.propTypes = {
  children: PropTypes.node.isRequired,
}

Section.defaultProps = {
  color:false,
}


export default Section
